import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-attachment-deeplink',
  imports: [MatProgressSpinner],
  templateUrl: './attachment-deeplink.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './attachment-deeplink.component.scss',
})
export class AttachmentDeeplinkComponent {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.router.navigate(['/attachment', this.route.snapshot.params['id']]);
  }
}
